import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Login';
import Registration from './Registration';
import Dashboard from './Dashboard';
import EmailAuth from './components/EmailAuth';
import AdminAccess from './components/AdminAccess';
import AddEmployee from './Employee/AddEmployee';
import Overview from './pages/Overview';
import DashboardPage from './pages/DashboardPage';
import Announcements from './pages/Announcements';
import Holidays from './pages/Holidays';
import PolicyPage from './pages/PolicyPage';
import HRDetail from './pages/HRDetail';
import EmployeeList from './pages/EmployeeList';
import TimesheetPage from './pages/TimesheetPage';
import ApplyLeave from './Leave/ApplyLeave';
// import LeaveHistory from './Leave/LeaveHistory';
import EditProfile from './AccountSetting/EditProfile';
import ResetPassword from './AccountSetting/ResetPassword';
import CreateUser from './AccountSetting/Createuser';
import ProfilePage from './AccountSetting/ProfilePage';
import SalarySlipPage from './Salary/SalarySlipPage';
import LeaveManagement from './LMS/LeaveManagement';
import FeedbackPage from './pages/FeedbackPage';
import ForgotPassword from './AccountSetting/ForgotPassword';
import ResetPass from './AccountSetting/ResetPass';
import NewEmployee from './Employee/NewEmployee';
import Referal from './pages/referal';
import RosterViewPage from './pages/RosterViewPage';
import HRdashboard from './pages/HRDashboard';
import AdminDashboard from './pages/AdminDashboard';
import ApplyResignationForm from './pages/ApplyResignationForm';
import PolicyDetail from "./pages/PolicyDetail";
import AnnouncementDetail from './pages/AnnouncementDetail';
import ApplyWorkFromHome from './Leave/ApplyWorkFromHome';
import EMPLeaveHistory from './Leave/EMPLeaveHistory';
import LeaveSummary from './Leave/LeaveSummary';
import WFHHistory from './Leave/WFHHistory';
import LeaveRequests from './HRDashboard/Leaverequest';
import LeaveHistory from './HRDashboard/LeaveHistory';
import WFHRequestsPage from './HRDashboard/WFHRequestsPage';
import AllEmployees from './HRDashboard/AllEmployees';
import CreateNotification from './HRDashboard/CreateNotification';
import CreateAnnouncementPage from './HRDashboard/CreateAnnouncementPage';
import SalarySlipRequestReview from './HRDashboard/SalarySlipRequestReview';
import HRAnnouncementPage from './HRDashboard/HRAnnouncementPage';
import HRNotificationPage from './HRDashboard/HRNotificationPage';
import HRHolidays from './HRDashboard/HRHolidays';
import HRAddHoliday from './HRDashboard/HRAddHoliday';
import EditEmployee from './HRDashboard/EditEmployee';
import HRResignationReviewPage from './HRDashboard/HRResignationReviewPage';
import RosterPage from './HRDashboard/RosterPage';
import Awards from './HRDashboard/Awards';
import Addawards from './HRDashboard/Addawards';
import Salarystatus from './Salary/Salarystatus';
import LeaveRequestsManager from './HRDashboard/LeaveRequestsManager';
import CarryForwardLeave from './HRDashboard/Addcarryforward';
import EmpCarryForwardLeave from './Leave/Carryforward';
import ApplyCarryForwardLeave from './Leave/ApplyCarryForwardLeave';
import CFLeaveApproval from './HRDashboard/CFLeaveApproval';
import AddAsset from './HRDashboard/AddAsset';
import AssetAssignments from './HRDashboard/AssetAssignments';
import AssetDashboard from './HRDashboard/AssetDashboard';
import EmployeeAssetProfile from './HRDashboard/EmployeeAssetProfile';
import ReportsExports from './HRDashboard/ReportsExports';
import AssetProfile from './HRDashboard/AssetProfile';
import NewAsset from './HRDashboard/NewAsset';
import AssetInventoryList from './HRDashboard/AssetInventoryList';


// ✅ Import the global session handler
import SessionHandler from './components/SessionHandler';

function App() {
  return (
    <Router>
      {/* SessionHandler mounted once globally */}
      <SessionHandler />

      <div>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/EmailAuth" element={<EmailAuth />} />
          <Route path="/AdminAccess" element={<AdminAccess />} />
          <Route path="/addemployee" element={<AddEmployee />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/resetpass" element={<ResetPass />} />

          {/* Dashboard with nested routes */}
          <Route path="/dashboard" element={<Dashboard />}>
            <Route index element={<DashboardPage />} />
            <Route path="home/overview" element={<Overview />} />
            <Route path="home/dashboard" element={<DashboardPage />} />
            <Route path="announcements" element={<Announcements />} />
            <Route path="announcements/view/:id" element={<AnnouncementDetail />} />
            <Route path="organization/holidays" element={<Holidays />} />
            <Route path="organization/policypage" element={<PolicyPage />} />
            <Route path="organization/policyview/:id" element={<PolicyDetail />} />
            <Route path="organization/hrdetail" element={<HRDetail />} />
            <Route path="organization/referal" element={<Referal />} />
            <Route path="team/employeelist" element={<EmployeeList />} />
            <Route path="timesheet/timesheetpage" element={<TimesheetPage />} />
            <Route path="leave/applyleave" element={<ApplyLeave />} />
            <Route path="leave/empleavehistory" element={<EMPLeaveHistory />} />
            <Route path="leave/leavesummary" element={<LeaveSummary />} />
            <Route path="leave/empCarryForwardLeave" element={<EmpCarryForwardLeave />} />
            <Route path="leave/applyCarryForwardLeave" element={<ApplyCarryForwardLeave />} />

            <Route path="leave/wfhhistory" element={<WFHHistory />} />
            <Route path="page/rosterviewpage" element={<RosterViewPage />} />
            <Route path="leave/ApplyWorkFromHome" element={<ApplyWorkFromHome/>}/>
            <Route path="leave/wfhrequestsPage" element={<WFHRequestsPage/>}/>
            <Route path="ManagerAcess/allemployees" element={<AllEmployees/>}/>
            <Route path="ManagerAcess/createnotification" element={<CreateNotification/>}/>
            <Route path="ManagerAcess/createannouncementPage" element={<CreateAnnouncementPage/>}/>
            <Route path="ManagerAcess/salarysliprequestreview" element={<SalarySlipRequestReview/>}/>
            <Route path="ManagerAcess/hrannoucementpage" element={<HRAnnouncementPage/>}/>
            <Route path="ManagerAcess/hrnotificationpage" element={<HRNotificationPage/>}/>
            <Route path="ManagerAcess/hrholidays" element={<HRHolidays/>}/>
            <Route path="ManagerAcess/hraddholiday" element={<HRAddHoliday/>}/>
            <Route path="ManagerAcess/awards" element={<Awards />} />
            <Route path="ManagerAcess/addawards" element={<Addawards />} />

            <Route path="ManagerAccess/editemployee/:id" element={<EditEmployee />} />
            <Route path="ManagerAccess/hrresignationreviewPage" element={<HRResignationReviewPage />} />
            <Route path="ManagerAccess/rosterpage" element={<RosterPage />} />
            <Route path="ManagerAccess/cfleaveApproval" element={<CFLeaveApproval />} />

            <Route path="ManagerAcess/addasset" element={<AddAsset />} />
            <Route path="ManagerAcess/assetassignments" element={<AssetAssignments />} />
            <Route path="ManagerAcess/assetdashboard" element={<AssetDashboard />} />
            <Route path="ManagerAcess/employeeassetprofile" element={<EmployeeAssetProfile />} />
            <Route path="ManagerAcess/reportsexports" element={<ReportsExports />} />
            <Route path="ManagerAcess/assetprofile" element={<AssetProfile />} />
            <Route path="ManagerAcess/newasset" element={<NewAsset />} />
            <Route path="ManagerAcess/assetinventorylist" element={<AssetInventoryList />} />

            {/* <Route path="leave/leavehistory" element={<LeaveHistory />} /> */}
            <Route path="Setting/editprofile" element={<EditProfile />} />
            <Route path="Setting/resetpassword" element={<ResetPassword />} />
            <Route path="Setting/createuser" element={<CreateUser />} />
            <Route path="Setting/profilepage" element={<ProfilePage />} />
            <Route path="Salary/salaryslippage" element={<SalarySlipPage />} />
            <Route path="LMS/LeaveManagement" element={<LeaveManagement />} />
            <Route path="Feedback/FeedbackPage" element={<FeedbackPage />} />
            <Route path="ManagerAcess/newemployee" element={<NewEmployee />} />
            <Route path="ManagerAcess/leaverequest" element={<LeaveRequests />} />
            <Route path="ManagerAcess/leaverequestmanager" element={<LeaveRequestsManager />} />
            <Route path="ManagerAcess/carryforwardleave" element={<CarryForwardLeave />} />

            <Route path="ManagerAcess/leavehistory" element={<LeaveHistory />} />
            <Route path="hr/hrdashboard" element={<HRdashboard />} />
            <Route path="admin/admindashboard" element={<AdminDashboard />} />
            <Route path="resignation/applyresignationform" element={<ApplyResignationForm />} />
            <Route path="Salary/salarystatus" element={<Salarystatus />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
